import React, { useEffect, useState } from 'react'
import "./index.css";
import "./task-page.css";
import Header from "../../components/Header";
import secureLocalStorage from "react-secure-storage";
import GridTask from "../../components/GridTask";
import ModalPrincipal from '../../components/ModalAlert/modal'
import { useNavigate } from 'react-router';
import ModalIncluirNovo2 from '../../components/ModalIncluirNovo2/modal'
import ModalIncluirNovo from '../../components/ModalIncluirNovo/modal'
import api from "../../Services/api";
import { AxiosResponse } from "axios";
import Loading from '../../components/Loading';
import GridSituacaoTask from '../../components/GridSituacaoTask'
import { v4 as uuidv4 } from 'uuid';
import MapView from '../../components/MapView/MapView'
import TaskGridLoadingPanel from '../../components/GridTask/TaskGridLoadingPanel'

const Direcionamento: React.FC = () => {

  const navigate = useNavigate();
  const [showGrid, setShowGrid] = useState(false);
  const [openModal, setOpenModal] = useState(false)
  const [qualAlert, setQualAlert] = useState(<></>)
  const [qualTitulo, setQualTitulo] = useState('')
  const [qualGrid, setQualGrid] = useState(<></>)
  const [tipoUser, setTipoUser] = useState('')
  const [openModalIncluirNovo, setOpenModalIncluirNovo] = useState(false)
  const [openModalIncluirNovo2, setOpenModalIncluirNovo2] = useState(false)
  const [isChecked, setIsChecked] = useState([])

  useEffect(() => {
    validatToken()
  }, []);


  async function validatToken() {

    let ret: AxiosResponse;

    const _user = secureLocalStorage.getItem('tpcm');
    api.defaults.headers.common['Authorization'] = _user as ''

    try {

      ret = await api.get("/status/validar")

      if (ret.data.status === 200) {

        setTipoUser(ret.data.decodedToken.acp_integrationid)
        secureLocalStorage.setItem('t', ret.data.data);
        secureLocalStorage.setItem('acp', ret.data.decodedToken.acp_integrationid);
        secureLocalStorage.setItem('n', ret.data.decodedToken.name);
        secureLocalStorage.setItem('iag', ret.data.decodedToken.id);
        secureLocalStorage.setItem('cy', ret.data.decodedToken.company);

        setShowGrid(true)
        setOpenModal(false)
      }

    } catch (e: any) {

      if (e.response === undefined) {
        setQualAlert(<div className='div-alert'>
          <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Sem comunicação com o servidor.</span></div>
          <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
        </div>)

        setOpenModal(true)
      } else
        if (e.response.status === 403) {

          setQualAlert(<div className='div-alert'>
            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
            <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado.</span></div>
            <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
          </div>)

          setOpenModal(true)

        } else {
          setQualAlert(<div className='div-alert'>
            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
            <div className='div-info-alert'><span className="info-alert">Não foi possível concluir sua solicitação.</span></div>
            <div className='btn-alert' onClick={fecharModal2}><span className="btn-alert-lab">OK</span></div>
          </div>)

          setOpenModal(true)
        }
    }

  }


  async function copiarTask(data: any) {
    let ret: AxiosResponse;

    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    let today = new Date();
    let date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      today.getDate().toString().padStart(2, "0");
    let time =
      today.getHours().toString().padStart(2, "0") +
      ":" +
      today.getMinutes().toString().padStart(2, "0");
    let datatimeAtual = date + "T" + time;

    const newUuid = uuidv4()


    let userAtual: null

    if (data.tea_id === '' || data.tea_id === null) {

      userAtual = data.age_id

    } else {

      userAtual = null

    }

    const dados = [{
      tsk_id: data.tsk_id,
      newUuid: newUuid,
      age_id_insert: secureLocalStorage.getItem('iag'),
    }]

    try {
      ret = await api.post("task/copy", {
        data: dados,
      });
      if (ret.data.status === 200) {


        const id = ret.data.data[0].tsk_id;
        const path = `/task/edit/${id}`;
        navigate(path);



      }

    } catch (e: any) {
      setQualAlert(<div className='div-alert'>
        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
        <div className='div-info-alert'><span className="info-alert">Não é possível criar a Tarefa.</span></div>
        <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
      </div>)
    }

  }


  function consultarSituacao(data: any) {


    setQualTitulo('Situação')

    setQualGrid((<><GridSituacaoTask
      th1='Adicionar'
      th2='ID'
      th3='Descrição'
      th4='Numero de Série'
      th5='Tombamento'
      th6=''
      endPoint='situationtask/listar'
      consult='N'
      col1='1'
      col2='2'
      col3='3'
      col4='0'
      id={data.tsk_id}
      outParams='N'
    /></>))

    setOpenModalIncluirNovo(true)

  }


  function pegarValores(data: any) {
    setIsChecked(data)
  }


  function fecharModal2() {
    setOpenModal(false)
  }

  function fecharOpenModalIncluirNovo() {
    setOpenModalIncluirNovo(false)
  }

  function fecharOpenModalIncluirNovo2() {
    setOpenModalIncluirNovo2(false)
  }

  function ModalDeletar() {

    const _type = secureLocalStorage.getItem('acp')


    setOpenModal(true)

    setQualAlert(<div className='div-alert'>
      <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
      <div className='div-info-alert-atencao'><span className="info-alert-atencao">Deseja deletar o registro?</span></div>
      <div className='div-info-alert'><span className="info-alert">Você não poderá reverter.</span></div>

      <div className='btn-alert-div'>
        <span className='btn-alert-esc' onClick={() => cancelarTask()}>
          <span className="btn-alert-lab">SIM</span>
        </span>
        <span className='btn-alert-dir' onClick={finalizarModal2}>
          <span className="btn-alert-lab">NÃO</span>
        </span>
      </div>
    </div>
    )
  }

  async function cancelarTask() {

    let ret: AxiosResponse;
    if (isChecked.length > 0) {
      setQualGrid(<><Loading /></>)

      try {
        ret = await api.delete("task/delete", {
          data: isChecked
        });
        if (ret.data.status === 200) {
          setOpenModal(false)
          window.location.reload();
        }
      } catch (e: any) {
        setOpenModal(false)
        setQualAlert(<div className='div-alert'>
          <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Não é possível cancelar as tarefas selecionadas.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>)
      }
    } else {
      setQualAlert(<div className='div-alert'>
        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
        <div className='div-info-alert'><span className="info-alert">Selecione ao menos um registro.</span></div>
        <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
      </div>)
    }

  }

  function finalizarModal2() {
    setOpenModal(false)
  }

  function fecharModal() {
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('tpcm')
    secureLocalStorage.removeItem('acp')
    secureLocalStorage.removeItem('n')
    secureLocalStorage.removeItem('iag')
    secureLocalStorage.removeItem('aua')
    navigate('/login');
    setOpenModal(false)
  }

  function confirmarPerfil() {
    setOpenModal(false)
  }

  async function funtoggle(_form?: any) {
    let ret: AxiosResponse;

    const _user = secureLocalStorage.getItem('tpcm')

    api.defaults.headers.common['Authorization'] = _user as ''

    try {

      ret = await api.get("/status/validar")

      if (ret.data.status === 200) {

        secureLocalStorage.setItem('t', ret.data.data);
        secureLocalStorage.setItem('acp', ret.data.decodedToken.acp_integrationid);
        secureLocalStorage.setItem('n', ret.data.decodedToken.name);
        secureLocalStorage.setItem('iag', ret.data.decodedToken.id);
        secureLocalStorage.setItem('cy', ret.data.decodedToken.company);

        if (tipoUser === 'DESENVOLVEDOR' || tipoUser === 'ADMINISTRADOR') {

          setQualTitulo('Campos Customizados')


          setOpenModalIncluirNovo(true)

        } else if (tipoUser === 'CONSULTOR') {

          setOpenModal(true)
          setQualAlert(<div className='div-alert'>
            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
            <div className='div-info-alert'><span className="info-alert">O seu perfil de acesso não permite deletar registros.</span></div>
            <div className='btn-alert' onClick={confirmarPerfil}><span className="btn-alert-lab">OK</span></div>
          </div>)

        }
      }

    } catch (e: any) {
      if (e.response.data.status === 403) {
        setQualAlert(<div className='div-alert'>
          <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
          <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
        </div>)

        setOpenModal(true)

      }
    }
  }

  async function visualizargps() {


    let ret: AxiosResponse;
    if (isChecked.length > 0) {
      setQualGrid(<><Loading /></>)

      try {
        ret = await api.get("task/taskgps", {
          params: {
            data: isChecked
          }
        });
        if (ret.data.status === 200) {
          setOpenModal(false)


          if (ret.data.data.length > 0) {

            setQualGrid(<MapView markersData={ret.data.data} />)
            setOpenModalIncluirNovo2(true)
          } else {

            setQualAlert(<div className='div-alert'>
              <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Não é possível exibir a localização.</span></div>
              <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          }



        } else {
          setQualAlert(<div className='div-alert'>
            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
            <div className='div-info-alert'><span className="info-alert">Não é possível exibir a localização.</span></div>
            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
          </div>)
          setOpenModal(true)
        }
      } catch (e: any) {


        setQualAlert(<div className='div-alert'>
          <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Não é possível cancelar as tarefas selecionadas.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)
      }
    } else {
      setQualAlert(<div className='div-alert'>
        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
        <div className='div-info-alert'><span className="info-alert">Selecione ao menos um registro.</span></div>
        <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
      </div>)
      setOpenModal(true)
    }

  }

  return (
    <>
      <div className="chamados-container">
        <Header />

        <main className="assignment-main">

          <div className="task-page">
            {!showGrid ? (
              <TaskGridLoadingPanel showSkeleton={false} />
            ) : null}
            {showGrid ? (
              <GridTask
                iconeExcluir={ModalDeletar}
                cancelarTask={pegarValores}
                th1="Ativo"
                th2="ID"
                th3="Onde"
                th4="Quem"
                th5="Previsto"
                th6="Executado"
                th7="Situação"
                th8="Tipo de tarefa"
                endPoint="task/buscartask"
                col1="1"
                col2="0"
                col3="2"
                col4="3"
                col5="4"
                col6="5"
                col7="13"
                col8="10"
                col9="0"
                col10="8"
                col11="9"
                col12="10"
                col13="11"
                fromAdd="/task/add"
                fromEdit="/task/edit"
                fromvisu={`/report/${String(secureLocalStorage.getItem("tp") || "")}`}
                btnDelete="S"
                pag="task"
                user="user/listar"
                team="team/listar"
                local="local/listarlocal"
                asset="asset/listaresset"
                tasksituation="tasksituation/listar"
                tasktype="tasktype/listar"
                correctivetype="correctivetype/listar"
                preventivetype="preventivetype/listar"
                buscartask="task/buscartask"
                fecharModal={fecharModal}
                copiarTask={copiarTask}
                consultarSituacao={consultarSituacao}
                onCustomFields={funtoggle}
                onCancelTasks={ModalDeletar}
                onViewGps={visualizargps}
              />
            ) : null}
          </div>

        </main>
      </div>


      <ModalPrincipal isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
        <div className='container-modal-alert'>
          {qualAlert}
        </div>
      </ModalPrincipal>

      <ModalIncluirNovo2 isOpen={openModalIncluirNovo2} setModalOpen={() => setOpenModalIncluirNovo2(!openModalIncluirNovo)}>
        <>
          <div className='title-modal-incluir'>
            <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
            <div onClick={fecharOpenModalIncluirNovo2}>
              <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>
          {qualGrid}
        </>
      </ModalIncluirNovo2>


      <ModalIncluirNovo isOpen={openModalIncluirNovo} setModalOpen={() => setOpenModalIncluirNovo(!openModalIncluirNovo)}>
        <>
          <div className='title-modal-incluir'>
            <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
            <div onClick={fecharOpenModalIncluirNovo} >
              <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>

          <div className='scrol-modal'>
            {qualGrid}
          </div>
        </>
      </ModalIncluirNovo>

    </>
  );
};

export default Direcionamento;
